export default "__VITE_ASSET__2mo6Qlcv__"